export default "__VITE_ASSET__xaw727mF__"